import script from "./LoaderCircle.vue?vue&type=script&setup=true&lang=js"
export * from "./LoaderCircle.vue?vue&type=script&setup=true&lang=js"

import "./LoaderCircle.vue?vue&type=style&index=0&id=4fa4d003&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fa4d003"]])

export default __exports__